import { useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import {
  selectAddressesConfigData,
  selectFormattedAddressList,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'

const useAddressSelect = (options = {}) => {
  const { onAddressChange, initialValue = {}, debounceMs = 1000, minSearchLength = 3 } = options

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { addressIsLoading } = useSelector(selectAddressesConfigData)
  const formattedAddressList = useSelector(selectFormattedAddressList)
  const [inputValue, setInputValue] = useState('')
  const searchTimerRef = useRef(null)

  const selectedValue =
    initialValue && Object.keys(initialValue).length > 0
      ? [
          {
            ...initialValue,
            id: initialValue.label || `${initialValue.streetNumber || ''} ${initialValue.streetName || ''}`.trim(),
            label:
              `${initialValue.streetNumber || ''} ${initialValue.streetName || ''} ${initialValue.zipcode || ''} ${initialValue.city || ''}`.trim(),
          },
        ]
      : []

  const searchAddresses = useCallback(
    query => {
      clearTimeout(searchTimerRef.current)
      if (!query || query.length < minSearchLength) return
      searchTimerRef.current = setTimeout(() => {
        dispatch({ type: subscriptionFormActionsV2.SEARCH_ADDRESS_V2, address: query })
      }, debounceMs)
    },
    [debounceMs, minSearchLength, dispatch],
  )

  const handleInputChange = event => {
    setInputValue(event.target.value)
    searchAddresses(event.target.value)
  }

  const handleSelectionChange = params => {
    if (onAddressChange) {
      if (params.value && params.value.length > 0) {
        onAddressChange([params.value[0]])
      } else {
        onAddressChange([])
      }
    }
  }

  const getOptionLabel = ({ option }) => {
    return {
      __html: option.label + '<br />' + (option.context || ''),
    }
  }

  return {
    addressList: formattedAddressList,
    selectedValue,
    isLoading: addressIsLoading,
    inputValue,
    handleInputChange,
    handleSelectionChange,
    getOptionLabel,
    searchAddresses,
    t,
  }
}

export default useAddressSelect
